import SideMenu from '@/containers/side-menu/SideMenu.vue';
import MovementInfo from '@/pages/movement-info/MovementInfo.vue';

export default [
  {
    path: '/account-movement-info/:movementId',
    name: 'MovementInfoEdit',
    components: {
      mainContent: MovementInfo,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'account-movement-info',
      },
      breadcrumb: {
        title: 'Atualização Movimentos',
        paths: [{ title: 'movimentos' }],
      },
    },
  },
  {
    path: '/account-movement-info',
    name: 'MovementInfo',
    components: {
      mainContent: MovementInfo,
      mainMenu: SideMenu,
    },
    meta: {
      role: {
        sectorId: 'account-movement-info',
      },
      breadcrumb: {
        title: 'Criação de Movimentos',
        paths: [{ title: 'movimentos' }],
      },
    },
  },
];
